{
  "Filter": "Фильтр",
  "Search": "Поиск",
  "Alarms": "Аварии",
  "Warnings": "Предупреждения",
  "Users": "Операторы",
  "Coolers": "Холодильники",
  "Active License": "Активная лицензия",
  "License Expired": "Срок действия лицензии",
  "Grace Period": "Льготный период",
  "Tenant Users": "Операторы-Владельцы",
  "Logout": "Выход",
  "Profile Update": "Обновление профиля",
  "Change Passowrd": "Изменение пароля",
  "Change Email": "Изменен6ие E-mail",
  "Dashboard": "Панель",
  "Manage": "Управление",
  "Rules": "Правила",
  "License Expires On": "Лицензия истекает",
  "Report": "Отчет",
  "Tenant List": "Список Владельцев",
  "Add Tenant": "Добавить Владельца",
  "Erp No": "Номер Erp",
  "Tenant": "Владелец",
  "License End Date": "Дата окончания лицензии",
  "Tenant Email": "E-mail владельца",
  "ERP Number": "Номер ERP",
  "Maximum number of coolers": "Максимальное число холодильников",
  "License Expiration": "Срок действия лицензии",
  "Tenant Details": "Детали Владельца",
  "TENANT EMAIL": "E-MAIL ВЛАДЕЛЬЦА",
  "COOLERS": "ХОЛОДИЛЬНИКИ",
  "Expire": "ИСТЕКАЕТ",
  "GEO LOCATION": "ГЕО-ЛОКАЦИЯ",
  "ERP NO": "НОМЕР ERP",
  "UPDATE": "ОБНОВИТЬ",
  "Disable Tenant": "Блокировать Владельца",
  "Move Coolers": "ПЕРЕМЕСТИТЬ ХОЛОДИЛЬНИКИ",
  "Do you really want to disable": "Вы действительно хотите отключить",
  "Cooler List": "Перечень Холодильников",
  "Search works on COOLER, COUNTRY, TAG/ALIAS columns only": "Поиск только по колонкам  ХОЛОДИЛЬНИК, СТРАНА, МЕТКА/ОБОЗНАЧЕНИЕ",
  "Cooler": "Холодильник",
  "Last Connected": "Последнее подключение",
  "Country": "Страна",
  "Tag/Alias": "Меткак/Обозначение",
  "User Information": "Информация Оператора",
  "Add New User": "Добавить новых Операторов",
  "Search works on ROLE, EMAIL, CREATE ALARMS, ACCESS TO columns only": "Поиск только по колонкам  РОЛЬ, E-MAIL, ВЫДАТЬ АВАРИИ, ДОСТУП К",
  "Role": "Роль",
  "Email": "E-mail",
  "Create Alarms": "Выдать Аварии",
  "Access To": "Доступ к",
  "Add User Details": "Добавить детали Оператора",
  "Edit User Details": "Изменить детали Оператора",
  "All Countries Selected": "Выбраны все страны",
  "Yes": "Да",
  "No": "Нет",
  "Alarm Information": "Информация об аварии",
  "Search works on UID, STATUS, COOLER, GEO LOCATION, RULE, ALARM TYPE, RESOURCE columns only": "Поиск только по колонкам  ИДЕНТИФИКАТОР ОПЕРАТОРА, СТАТУС, ХОЛОДИЛЬНИК, ГЕО-ЛОКАЦИЯ, ТИП АВАРИИ, РЕСУРС",
  "UID": "ИДЕНТИФИКАТОР ОПЕРАТОРА",
  "Geo Location": "Гео-Локация",
  "Status": "Статус",
  "Alarm Type": "Тип Аварии",
  "Rule": "Правило",
  "Resource": "Ресурс",
  "Alarm Rules": "Правила Аварий",
  "Add New Rule": "Добавить Правило Аварий",
  "Search works on ID, STATUS, ALARM NAME, SEVERITY columns only": "Поиск только по колонкам ИДЕНТИФИКАТОР, СТАТУС, НАЗВАНИЕ АВАРИИ, СТРОГОСТЬ",
  "All": "Все",
  "All Controller with Geo Location": "Все Контроллеры с Гео-Локацией",
  "ID": "ИДЕНТИФИКАТОР",
  "Alarm Name": "Название Аварии",
  "Limit": "Предел",
  "Severity": "Строгость",
  "BACK": "НАЗАД",
  "Last Connected On": "Последнее Соединение к ",
  "Resources Data": "Данные Ресурсов",
  "Tag Name": "Название метки",
  "Update Tag or Alias Name": "Обновить метку или обозначение",
  "Update": "Обновить",
  "Export": "Экспорт",
  "DAY": "ДЕНЬ",
  "WEEK": "НЕДЕЛЯ",
  "MONTH": "МЕСЯЦ",
  "Loading latest telemetry data ... ": "Загрузка последних данных телеметрии ... ",
  "Loading telemetry data ... ": "Загрузка данных телеметрии ...",
  "No Data to display": "Нет данных для показа",
  "Resources": "Ресурсы",
  "Min": "Минимум",
  "Max": "Максимум",
  "Value": "Значение",
  "Timestamp": "Временная отметка",
  "Save": "Сохранить",
  "Cancel": "отменить",
  "Save and Apply": "Сохранить и применить",
  "Move": "Переехать",
  "Add Alarm Details": "Добавить детали Аварии",
  "Update Alarm Details": "Обновить Делали Аварии",
  "Controller": "Контроллер",
  "Limits": "Пределы",
  "Notified To": "Сообщать",
  "Apply To": "Применить к",
  "Max Distance": "Максимальная удаленность",
  "Controller Name": "Название Контроллера",
  "All Controller In": "Все контроллеры в",
  "High": "Высокое",
  "Low": "Низкое",
  "Parameters": "Параметры",
  "Parameter": "Параметр",
  "Select Controller": "Выбрать Контроллер",
  "Select Controllers": "Выбрать Контроллеры",
  "Select Resource": "Выбрать Ресурс",
  "Success Message": "Сообщение об успехе",
  "Error": "Ошибка",
  "Are you sure to Delete User?": "Вы точно хотите удалить Оператора?",
  "User deleted successfully.": "Оператор успешно удален.",
  "Invalid Email": "Неправильный E-mail",
  "Email field should not be empty.": "Поле E-mail не может быть пустым.",
  "Email entered is not a valid email.": "Введенный E-mail недействителен.",
  "Invalid Role": "Некорректное правило",
  "Select a role.": "Выберите правило.",
  "Updated successfully.": "Успешно Обновлено.",
  "added successfully.": "успешно добавлено.",
  "Error occurred while adding user, please try again.": "Ошибка добавления Оператора, попробуйте еще раз.",
  "Invalid Controller": "Некорректный контроллер",
  "Select a Controller": "Выберите контроллер",
  "Invalid Resource": "Некорректный ресурс",
  "Select a Resource": "Выберите ресурс",
  "Invalid Min Value": "Неправильный нижний предел",
  "Enter a valid Min Value.": "Введите верный Нижний предел",
  "Invalid Max Value": "Неправильный верхний предел",
  "Enter a valid Max Value.": "Введите верный Верхний предел",
  "Invalid Max Distance Value": "Неправильное значение максимальной удаленности",
  "Enter a valid Max Distance Value.": "Введите правильную максимальную удаленность",
  "Invalid Notify Mail Ids": "Неправильный идентификатор почтовых сообщений",
  "Enter valid mail Ids.": "Введите правильный почтовый идентификатор",
  "Select a valid controller in apply to section.": "Выберите реальный контроллер для использования в секции",
  "Invalid Countries": "Неверная страна",
  "Select one or more countries apply to section.": "Выберите одну или несколько стран для использования в секции",
  "Invalid Rule Name": "Неправильное название Правила",
  "Enter a valid rule name.": "Введите правильное название Правила",
  "added successfully": "успешно добавлено",
  "updated successfully": "Успешно Обновлено",
  "Error occurred while adding/updating Rule, please try again.": "Ошибка добавления/обновления Правила, попробуйте еще раз",
  "Activated successfully": "Активирован успешно",
  "Deactivated successfully": "Деактивирован успешно",
  "Deleted successfully.": "Удалено успешно.",
  "Are you sure to Delete Rule?": "Вы точно хотите удалить Правило?",
  "Invalid TenantName": "Неверное имя владельца",
  "Tenant Name field should not be empty.": "Поле владельца не может быть пустым",
  "Invalid ERP No": "Неверный номер ERP",
  "ERP NO field should not be empty.": "Поле номера ERP не может быть пустым.",
  "Invalid CoolersCount": "Неправильный счетчик охладителей",
  "Please enter valid Coolers": "Пожалуйста, введите реальные охладители",
  "Invalid Cooler Value": "Неправильное значение охладителя",
  "Enter a valid Cooler Number Value.": "Введите правильное значение числа охладителей",
  "Invalid Expiry Date": "Неправильная дата действия",
  "Please select Expiry Date": "Пожалуйста введите правильную дату действия",
  "Tenant added successfully.": "Владелец успешно добавлен.",
  "Error occurred while adding tenant, please try again.": "Ошибка добавления владельца, попробуйте еще раз.",
  "Tenant Updated successfully.": "Владелец успешно обновлен.",
  "Error occurred while updating tenant, please try again.": "Ошибка обновления владельца, попробуйте еще раз.",
  "Reports": "Отчеты",
  "Search works on Erp No, Tenant, Geo Location only": "Возможен поиск только по № Erp, Tenant, Geo Location only",
  "Update Tenant": "Обновить Владельца",
  "Select Expiry License Date": "Выберите дату окончания лицензии",
  "Registered Tenant": "Зарегистрированный Владелец",
  "Registered Users": "Зарегистрированные Операторы",
  "Users under Tenant": "Операторы Владельца",
  "Renewal notification sent to Tenant": "Отправлять сообщение об обновлении Владельцу",
  "Number of coolers under Tenant": "Количесвко Холодильников Владельца",
  "Date": "Дата",
  "Choose Format": "Выберите Формат",
  "Generate Report": "Сгенерировать Отчет",
  "Select": "Выбрать",
  "Active Alarms": "Активные Аварии",
  "Associated Resources": "Связанные Ресурсы",
  "Associated Users": "Связанные Операторы",
  "Coolers List": "Список Холодильников",
  "Device": "Устройство",
  "User Device Information": "Информация пользователя о приборе",
  "Mobile Name": "Название Мобильника",
  "Mobile Model": "Модель  Мобильника",
  "Legal": "Узаконенный",
  "Privacy Policy": "Политика Конфиденциальности",
  "Copyright": "Авторское право",
  "No Records found": "записей не найдено",
  "Billing Address": "Платежный адрес",
  "Search works on Email, Mobile Name, Mobile Model": "Поиск работает с электронной почтой, именем мобильного телефона и моделью мобильного телефона.",
  "Are you sure to Delete ?": "Вы уверены, что хотите удалить?",
  "No results found!": "Результаты не найдены!",
  "Select Country": "выберите страну",
  "Start Date": "Дата начала",
  "End Date": "Дата окончания",
  "Select Start Date": "Выберите дату начала",
  "Select End Date": "Выберите дату окончания",
  "Invalid Start Date": "Неверная дата начала",
  "Invalid End Date": "Неверная дата окончания",
  "Invalid Controllers List": "Список недействительных контроллеров",
  "Please wait report is getting ready for Download": "Пожалуйста, подождите, отчет готовится к загрузке",
  "downloadFaild": "Не удалось загрузить",
  "Format": "Формат",
  "Controllers": "Контроллеры",
  "Downloads in Progress": "Выполняется загрузка",
  "Do you agree?": "Вы согласны?",
  "All the files downloaded Successfully": "Все файлы успешно загружены",
  "No files found": "Файлы не найдены",
  "You have cancelled the Downloads": "Вы отменили загрузку",
  "Warning": "Предупреждение",
  "Driver Manager": "Диспетчер драйверов",
  "Driver File Name": "Имя файла драйвера",
  "Mask": "маскировать",
  "Uploaded By": "Загружено пользователем",
  "Uploaded On": "Загружено на",

  "Are you sure to Delete Driver?": "Вы уверены, что хотите удалить драйвер?",
  "Please upload a valid file": "Пожалуйста, загрузите действительный файл",
  "Driver file already exists": "Файл драйвера уже существует",
  "Are you sure you want to Overwrite?": "Вы уверены, что хотите перезаписать?",
  "Download Success!": "Скачать Успех!",
  "File Deleted Successfully": "Файл успешно удален",
  "Trying to upload a non verified driver": "Попытка загрузить неподтвержденный драйвер",
  "Driver File Uploaded": "Файл драйвера загружен",
  "File name should not be more than 50 characters": "Имя файла не должно быть более 50 символов",
  "Unit": "единица",
  "Action": "действие",
  "Bad Request": "Неверный запрос",
  "Invalid input fields": "Неверные поля ввода",
  "Invalid Tag Name": "Неверное имя тега",
  "Coolers by Country": "Кулеры по стране",
  "Enable/Disable": "Включить выключить",
  "Actions": "действия",
  "Controller Model": "Модель контроллера",
  "Selected Resources Data": "Данные выбранных ресурсов",
  "Last 24Hr": "Последние 24 часа",
  "View Data": "Просмотр данных",
  "Note: Maximum of 8 resources are allowed to view data": "Примечание. Для просмотра данных разрешено не более 8 ресурсов.",
  "Get Data": "Получить данные",
  "Until": "До того как",
  "Tag Updated Successfully": "Тег успешно обновлен",
  "Add Tag Name..": "Добавить имя тега ..",
  "Select Tenant": "Выберите Арендатора",
  "Tenant Disabled Successfully.": "Арендатор успешно отключен.",
  "Cooler moved successfully.": "Кулер переехал успешно.",
  "Unknown error occurred, Please try again.": "Произошла неизвестная ошибка, пожалуйста, попробуйте еще раз.",
  "No cooler/coolers availabe to move": "Нет кулера / кулера для перемещения",
  "The target Tenant does not have enough space for the new coolers": "Целевому Арендатору не хватает места для нового кулера",
  "Tenant is not selected": "Арендатор не выбран",
  "Please select Tenant": "Пожалуйста, выберите Арендатор",
  "Select Countries": "Выберите страны",
  "Country List": "Список стран",
  "Controller List": "Список контроллеров",
  "Notified Email To": "Уведомление по электронной почте",
  "Close": "близко",
  "Disable": "Отключить",
  "Note: Once disabled you can not enable again.": "Примечание: после отключения вы не можете включить снова.",
  "Delete  Rule": "Удалить правило",
  "Delete Device": "Удалить устройство",
  "Ok": "Ok",
  "Hi": "Привет",
  "Commandes": "Команды",
  "Access Restricted Notice!": "Уведомление об ограниченном доступе!",
  "Your License has expired. Please Contact your Admin.": "Срок действия вашей лицензии истек. Пожалуйста, обратитесь к своему администратору",
  "Online": "Подсоединено",
  "Offline": "Отсоединено",
  "Total": "Всего",
  "Processing...": "Выполняется обработка...",
  "Request Process Successfully": "Обработка запроса успешно выполнена",
  "Error occurred while processing request, please try again.": "При обработке запроса произошла ошибка, пожалуйста, повторите попытку.",
  "Menu": "Меню",
  "Device Groups": "Группы устройств",
  "HACCP Report": "Отчет HACCP",
  "Statistics": "Статистика",
  "Device List": "Список устройств",
  "All Devices": "Все устройства",
  "Search works on Device, Groups, Alarms, Country columns": "Поиск осуществляется по столбцам «Устройство», «Группы» , «Аварийные сигналы», «Страна»",
  "Dongle UId": "UId модуля Dongle",
  "Active": "Активный",
  "InActive": "Неактивный",
  "Group(s)": "Группа (группы)",
  "Device Details": "Данные устройства",
  "View Value": "Посмотреть значение",
  "Group Name": "Имя группы",
  "Device Name": "Имя устройства",
  "Description": "Описание",
  "Created Date (UTC)": "Дата создания (UTC)",
  "Added By": "Добавлено",
  "Search works on Group Name, Description columns": "Поиск осуществляется по столбцам «Имя группы», «Описание» ",
  "Add Group Details": "Добавить данные группы",
  "Edit Group Details": "Редактировать данные группы",
  "Name of the Group": "Имя группы",
  "Create New Group": "Создать новую группу",
  "Select Devices": "Выбрать устройства",
  "Group Information": "Информация о группе",
  "Add Description": "Добавить описание",
  "Device Count": "Отсчет устройств",
  "Alarm Count": "Отсчет аварийных сигналов",
  "Device Status": "Состояние устройства",
  "Groups Count": "Отсчет групп",
  "Device by Group": "Устройства по группам",
  "Alarms By Device Status": "Аварийные сигналы состояния устройств",
  "Device Status Count": "Отсчет статуса устройства",
  "Alarms By Devices Over Time": "Аварийные сигналы там-аута устройств",
  "Real Time": "Реальное время",
  "Last 24 Hrs": "Последние 24 часа",
  "Last Week": "Последняя неделя",
  "Last Month": "Последний месяц",
  "Last 3 Months": "Последние 3 месяца",
  "Last 1 Year": "Последний год",
  "Last 6 Months": "Последние 6 месяцев",
  "Devices": "Устройства",
  "OEM": "OEM",
  "Name": "Имя",
  "OEM\/Parent": "OEM\/Материнская компания",
  "Create Users": "Создать пользователей",
  "Selected Countries": "Выбранные страны",
  "Selected Devices": "Выбранные устройства",
  "Enabled": "Активировано",
  "Disabled": "Деактивировано",
  "Groups": "Группы",
  "Groups List": "Список групп",
  "Select Groups": "Выбрать группы",
  "Telemetry": "Телеметрия",
  "Filters": "Фильтры",
  "Show Favorites": "Показать избранное",
  "Favorites": "Избранное",
  "Label": "Этикетка",
  "Current Value": "Текущее значение",
  "Operations": "Операции",
  "Read All": "Прочитать все",
  "Settings": "Настройки",
  "Set Value": "Задать значение",
  "Mobile UId": "UId мобильного устройства",
  "Mobile OS | Version": "ОС мобильного устройства | Версия",
  "Issued On": "Выпущено",
  "Active Device(s)": "Активное устройство (устройства)",
  "In-active Device(s)": "Неактивное устройство (устройства)",
  "Block User": "Заблокировать пользователя",
  "Unblock User": "Разблокировать пользователя",
  "Driver Upload": "Загрузить драйвер",
  "Search works on Driver File Name, Mask, and Uploaded By columns": "Поиск осуществляется по столбцам «Имя файла драйвера», «Маска» и «Загружено»",
  
  "Add new report": "Добавить новый отчет",
  "Report Name": "Имя отчета",
  "Report Frequency": "Частота отчетов",
  "Daily": "Ежедневно",
  "Weekly": "Еженедельно",
  "Monthly": "Ежемесячно",
  "Data Frequency": "Частота данных",
  "PDF": "PDF",
  "CSV": "CSV",
  "XLSX": "XLSX",
  "Delete Report :": "Удалить отчет:",
  "Add Report": "Добавить отчет",
  "Update Report Details": "Обновить данные отчета",
  "Select Data Frequency": "Выбрать частоту данных",
  "One time per day": "Раз в день",
  "Two times per day": "Два раза в день",
  "Three time per day": "Три раза в день",
  "Four times per day": "Четыре раза в день",
  "Select Device": "Выбрать устройство",
  "Data Frequency is Mandatory": "Частота данных является обязательной",
  "Device is Mandatory": "Устройство является обязательным",
  "Resource is Mandatory": "Ресурс является обязательным",
  " Notified to email is Mandatory": " Уведомление по электронной почте является обязательным",
  "Maximum 8 resources can be selected": "Может быть выбрано максимум 8 ресурсов",
  "Invalid OEM": "Неверный OEM",
  "Select an OEM": "Выбрать OEM",
  "User already exist": "Пользователь уже существует",
  "Email or Role is not valid": "Неверны адрес электронной почты или роль",

  "You are currently blocked. Please contact system administrator for details or to restore access. <System Admin EMAIL ID>": "В настоящее время вы заблокированы. Обратитесь к системному администратору за подробностями или для восстановления доступа. <System Admin EMAIL ID>",
  "Invalid Device": "Неверное устройство",
  "Invalid Group": "Неверная группа",
  "Error Deleting Alarm Rule": "Ошибка при удалении правила аварийного сигнала",
  "Are you sure to Block ?": "Вы действительно хотите заблокировать?",
  "Are you sure to Unblock ?": "Вы действительно хотите разблокировать?",
  "Error downloading driver file": "Ошибка при скачивании файла драйвера",
  "Group deleted successfully": "Группа успешно удалена",
  "Failed to delete group": "Не удалось удалить группу",
  "Group created successfully": "Группа успешно создана",
  "Group details updated successfully": "Данные группы успешно обновлены",
  "Failed to create\/edit group": "Не удалось создать\/отредактировать группу",
  "Group Name already exist": "Имя группы уже существует",
  "Group Name already exist\/duplicate Group Name": "Имя группы уже существует\/дублировать имя группы",
  "Model is not valid": "Неверная модель",
  "Name\/Desc is not valid": "Неверная модель\/описание",
  "One\/More selcted device is invalid or the user doesn't have access": "Одно или несколько выбранных устройств является неверным или у пользователя нет доступа",
  "User has no access to the group": "У пользователя нет доступа к группе",
  "Failed to fetch data": "Не удалось получить данные",
  "Error deleting file ": "Ошибка при удалении файла ",
  "Error occurred while adding\/updating Report, please try again.": "При добавлении\/обновлении отчета произошла ошибка, пожалуйста, повторите попытку.",
  "Commands": "Команды",
  "Are you sure to Delete Report?": "Вы действительно хотите удалить отчет?",
  "Error Deleting Report": "Ошибка при удалении отчета",
  "User has no access to the Haccp Report": "У пользователя нет доступа к отчету Haccp",
  "Report name is not valid": "Неверное имя отчета",
  "Invalid Controller type": "Неверный тип контроллера",
  "Duplicate report name": "Дублированное имя отчета ",
  "Support": "Поддерживать",
  "FAQ's": "FAQ's",
  "Add OEM": "Добавить ОЕМ",
  "History": "История",
  "Version": "Версия",
  "v3.2": "v3.2",
  "Terms and Conditions": "Условия и положения",
  "Search works on OID,OEM Name,OEM Description": "Поиск работает по OID, OEM Name, OEM Description",
  "OEM Description": "OEM Description",
  "OEM Name": "OEM Name",
  "OID": "OID",
  "Home": "Дом",
  "Management": "Управление",
  "Phone/Tablet": "Телефон/планшет",
  "Data Export": "Экспорт данных",
  "Export Json": "Экспорт JSON",
  "Map View": "Просмотр карты",
  "Count": "считать",
  "Added On": "Добавленные",
  "Modbus slave ID": "Modbus slave ID",
  "Controller Type Name": "Название типа контроллера",
  "Device Type": "Тип устройства",
  "Group Count": "Отсчет групп",
  "Day": "День",
  "Hour": "Час",
  "Start": "Старт",
  "End": "Конец",
  "Poli": "Poli",
  "Mask": "Маска",
  "Search works on Report Name,Report Frequency, and Notified Email columns": "Поиск осуществляется по столбцам «Имя отчета», «Частота отчета» и «Электронное письмо с уведомлением»",
  "Release": "выпуск",
  "PCH": "PCH",
  "Location": "расположение",
  "Dsp Id": "Dsp Id",
  "Firmware Version": "Версия ПО",
  "Device Metadata": "Метаданные устройства",
  "Alarms count by device's status": "Отсчет аварийных сигналов по статусу устройства",
  "Alarms count group by device's status and device": "Группирование отсчетов аварийных сигналов по статусу устройства и по устройствам",
  "Alarm Count distribution over time": "Распределение отсчета аварийных сигналов с течением времени",
  "Alarm status count over time": "Отсчет статуса аварийных сигналов с течением времени",
  "Device by Controller Model": "Устройство по модели контроллера",
  "Select columns": "Выбрать столбцы",
  "columns selected": "выбранные столбцы",
  "Favourites": "Избранное"



}
